// Same-origin API — the BFF proxies /api/* to the ERP. MAIN_SITE is where menu/footer links point.
export const API_BASE = process.env.REACT_APP_API_BASE || '/api';
export const MAIN_SITE = process.env.REACT_APP_MAIN_SITE || 'https://www.adelgroups.com';
